import React, { useState } from 'react';
import { GripVertical } from 'lucide-react';
import { isLate, matchesQuery, plusOneComing, plusOneLabel } from './seatingUtils';

// Unseated guests; drag a row onto any table on the floor plan.
export const GuestPool = ({ guests, onPick }) => {
  const [q, setQ] = useState('');
  const [lateOnly, setLateOnly] = useState(false);
  const late = guests.filter(isLate).length;
  const list = guests.filter((g) => (!lateOnly || isLate(g)) && matchesQuery(g, q));
  return (
    <div data-testid="unassigned-drop-zone" className="flex flex-col min-h-0">
      <div className="flex items-center gap-2 mb-2">
        <p className="text-sm font-medium text-[#2A2A2A] flex-1">Not seated yet <span className="text-[#9A8A7E]">({guests.length} {guests.length === 1 ? 'invite' : 'invites'})</span></p>
        {late > 0 && (
          <button data-testid="unassigned-late-filter" onClick={() => setLateOnly((v) => !v)} className={`text-[11px] px-2.5 py-0.5 rounded-full border ${lateOnly ? 'bg-[#7B2C3B] text-white border-[#7B2C3B]' : 'border-[#EFE3D8] text-[#7B4A1A]'}`}>Late ({late})</button>
        )}
      </div>
      <input data-testid="unassigned-filter" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by name" className="mb-2 px-3 py-1.5 rounded-full border border-[#EFE3D8] text-xs focus:outline-none focus:border-[#7B2C3B]" />
      <ul className="space-y-1 overflow-auto max-h-[52vh] pr-1">
        {list.map((g) => (
          <li key={g.id} data-testid={`guest-chip-${g.id}`} draggable onDragStart={(e) => { e.dataTransfer.setData('text/guest-id', g.id); e.dataTransfer.effectAllowed = 'move'; }}
            onClick={() => onPick?.(g)}
            className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white border border-[#EFE3D8] hover:border-[#B8896C] cursor-grab active:cursor-grabbing text-sm">
            <GripVertical className="w-3.5 h-3.5 text-[#C9B8A8] shrink-0" />
            <span className="flex-1 min-w-0 truncate">{g.name}{plusOneComing(g) && <span className="text-[11px] text-[#9A8A7E]"> + {plusOneLabel(g)}</span>}</span>
            {isLate(g) && <span data-testid={`late-chip-badge-${g.id}`} className="text-[9px] uppercase px-1.5 rounded-full bg-[#7B2C3B] text-white">Late</span>}
            <span className="text-[10px] text-[#9A8A7E]">{plusOneComing(g) ? 2 : 1}</span>
          </li>
        ))}
        {!list.length && <li className="text-xs text-[#9A8A7E] py-2">{guests.length ? 'No match.' : 'Everyone has a seat.'}</li>}
      </ul>
      <p className="text-[10px] text-[#9A8A7E] mt-2">Drag a name onto a table, or select a table and search.</p>
    </div>
  );
};

export default GuestPool;
